<template>
    <div class="print-preview">
        <h3 class="mb-4">{{ title }}</h3>
        <hr>
        <div class="d-flex flex-wrap mb-4 detail">
            <template v-for="p in data">
                <div class="flex-fill w-50 p-1"><span><strong>{{p.key | rowTitleFormat}}:</strong></span> {{ p.value }}
                </div>
            </template>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      title: String,
      data: Array
    },
    data() {
      return {}
    }
  }
</script>

<style scoped lang="scss">
    .print-preview {
        .detail {
            color: #303a42;
        }

        hr {

        }
    }

</style>


// WEBPACK FOOTER //
// src/views/Patient/Print/PatientSection.vue